<div style="padding: 24px;">
    <h1 mat-dialog-title>{{model.title | translate}}</h1>
    <mat-dialog-content class="mat-typography">
        <p>{{model.text | translate}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex flex-row justify-content-between buttons">
        <button mat-button mat-dialog-close (click)="onClose(false)" autofocus="false">{{Localization.Cancel | translate}}</button>
        <button mat-button mat-dialog-close (click)="onClose(true)" autofocus="false">{{Localization.Proceed | translate}}</button>
    </mat-dialog-actions>
</div>

